import React from 'react'
export const CustomSortIcon = (
  <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.64645 4.14645C3.84171 3.95118 4.15829 3.95118 4.35355 4.14645L8 7.79289L11.6464 4.14645C11.8417 3.95118 12.1583 3.95118 12.3536 4.14645C12.5488 4.34171 12.5488 4.65829 12.3536 4.85355L8.35355 8.85355C8.15829 9.04882 7.84171 9.04882 7.64645 8.85355L3.64645 4.85355C3.45118 4.65829 3.45118 4.34171 3.64645 4.14645Z'
      fill='#212529'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M1 11.5C1 11.2239 1.22386 11 1.5 11L14.5 11C14.7761 11 15 11.2239 15 11.5C15 11.7761 14.7761 12 14.5 12L1.5 12C1.22386 12 1 11.7761 1 11.5Z'
      fill='#212529'
    />
  </svg>
)
